import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const Adhd = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              ADHD
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              What If You're Not Distracted — Just Outnumbered?
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  We've all done it. You sit down to answer an email and somehow end up
                  reading a news article, checking the weather, looking up a song you
                  haven't heard since university, and wondering why you walked into the
                  kitchen in the first place. For most of us, that's an occasional lapse.
                  But for someone with ADHD, it can feel like a way of life.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  ADHD is often portrayed as a childhood disorder involving restless
                  children bouncing off classroom walls. But the reality is far more
                  complicated. Millions of adults live with ADHD, many without realizing
                  it, and the condition is about much more than simply "not paying
                  attention." In fact, one of the biggest misconceptions about ADHD is
                  hidden in its name.
                </p>

                <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                People with ADHD don&apos;t necessarily have a deficit of attention —
                they often have difficulty controlling where their attention goes.
                Imagine trying to read a book while every conversation in a café
                competes equally for your attention. 
              </p>

              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/adhd-information-page.png"
                  alt="ADHD"
                  className="w-full max-w-[700px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Imagine trying to focus on a work
                project while your brain continually insists that half a dozen other
                thoughts deserve equal consideration. Imagine having brilliant ideas
                but struggling to hold onto them long enough to turn them into action.  This isn&apos;t laziness. It isn&apos;t a lack of intelligence. And it
                certainly isn&apos;t a moral failing. It is a challenge involving some
                of the brain&apos;s most important executive functions: attention,
                inhibition, working memory, and cognitive control.
              </p>
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Over the last few years, my team has been investigating whether these
                executive function challenges can be measured more objectively than
                the questionnaires and interviews traditionally used to diagnose ADHD.
                By analysing data from tens of thousands of people, we found that
                relatively simple cognitive tests could reliably distinguish adults
                diagnosed with ADHD from those who had not been diagnosed. One of the
                strongest predictors wasn&apos;t how much people knew — it was how
                effectively they could inhibit an automatic response when their
                attention was being pulled in the wrong direction.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you&apos;ll discover why the
                frontal lobes play such a central role in ADHD, what neuroscience has
                revealed about the brain networks involved, why medication helps some
                people but not others, and how strategies ranging from mindfulness to
                structured routines can strengthen the executive functions that
                underpin everyday life. Because ADHD isn&apos;t about having too little
                attention. It&apos;s about trying to conduct an orchestra when every
                musician wants to play a different tune.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK HERE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Adhd;